import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {selectStore} from "../../../../../../store/selector";
import {fetchCheckEmailAction, fetchCheckIinAction} from "../../../../../../store/pages/admission/actions";
import {StyledFirstStep} from "./index.styles";
import {Select, Form, Spin, Alert, Row, Radio, Button, Divider, DatePicker, ConfigProvider} from "antd";
import {Trans, useTranslation} from "react-i18next";
import {MyInput} from "../../../../../common/MyInput/MyInput";
import {MyCheckbox} from "../../../../../common/MyCheckbox/MyCheckbox";

import locale from "antd/locale/ru_RU"

import "dayjs/locale/ru.js"

dayjs.locale("ru")

import countries from '../../../../../../assets/static/countries.json'
import warningIcon from '../../../../../../assets/icons/page/entrant/admission/icon_warning.svg'
import dayjs from "dayjs";

const {Option} = Select

export const FirstStep = ({layout, formRef, educationOrder, onFinishFailed, onFinish, error, setError, isExecutor}: any) => {
  const dispatch = useDispatch();
  const {t} = useTranslation('admission') ;

  const {profile: {userProfile: profileState},admission: {provinces: provincesState, checkIin: checkIinState, checkEmail: checkEmailState}} = useSelector(selectStore)

  const applicationData = educationOrder.data

  const initValue = {
    declarant_type: applicationData && applicationData.declarant_type ? applicationData.declarant_type : '1',
    declarant_status: applicationData ? applicationData.declarant_status : undefined,
    iin_parent: applicationData ? applicationData.iin_parent : '',
    parent_surname: applicationData ? applicationData.parent_surname : '',
    birthday_entrant: applicationData ? dayjs(applicationData.birthday_entrant, "YYYY-MM-DD") : '',
    birthday_parent: applicationData ? dayjs(applicationData.birthday_parent, "YYYY-MM-DD") : '',
    parent_name: applicationData ? applicationData.parent_name : '',
    parent_patronymic_entrant: applicationData ? applicationData.parent_patronymic_entrant : '',
    iin_entrant: applicationData ? applicationData.iin_entrant : undefined,
    surname_entrant: applicationData ? applicationData.surname_entrant : undefined,
    name_entrant: applicationData ? applicationData.name_entrant : undefined,
    patronymic_entrant: applicationData ? applicationData.patronymic_entrant : undefined,
    declarant_address: applicationData ? applicationData.declarant_address : undefined,
    phone_entrant: applicationData ? applicationData.phone_entrant : undefined,
    email_entrant: applicationData ? applicationData.email_entrant : undefined,
    base_education: applicationData ? applicationData.base_education : undefined,
    child_invalid: applicationData ? applicationData.child_invalid : null,
    quota: applicationData ? applicationData.quota : null,
    invalid1and2: applicationData ? applicationData.invalid1and2 : '2',
    vov: applicationData ? applicationData.vov : '2',
    village_soc_ek: applicationData ? applicationData.village_soc_ek : '2',
    faces_kaz_nac_without_rk: applicationData ? applicationData.faces_kaz_nac_without_rk : '2',
    children_without_parent: applicationData ? applicationData.children_without_parent : '2',
    village_rk: applicationData ? applicationData.village_rk : '2',
    children_many: applicationData ? applicationData.children_many : '2',
    family_half: applicationData ? applicationData.family_half : '2',
    family_with_invalid: applicationData ? applicationData.family_with_invalid : '2',
    conscript: applicationData ? applicationData.conscript : '2',
    hostel: applicationData ? applicationData.hostel : null,
    social_help: applicationData ? applicationData.social_help : null,
    enbek: applicationData ? applicationData.enbek : null,
    accepted: applicationData && applicationData.iin_entrant ? true : undefined,
    user_accepted: applicationData && applicationData.iin_entrant ? true : undefined,
    country: applicationData ? applicationData.country : undefined,
    region: applicationData && applicationData && applicationData.region ? parseInt(applicationData.region) : undefined,
    district: applicationData && applicationData && applicationData.district ? parseInt(applicationData.district) : undefined,
    school: applicationData && applicationData.school ? parseInt(applicationData.school) : undefined,
    series_certificate: applicationData ? applicationData.series_certificate : undefined,
    number_certificate: applicationData ? applicationData.number_certificate : undefined
  }


  const [formData, setFormData] = useState(initValue)
  const [idxForSelect, setIdxForSelect] = useState({
    idxProvince: null,
    idxRegion: null
  })

  const onValuesChange = (changedField:any, allFields:any) => {

    if(changedField.declarant_type){
      if(changedField.declarant_type === "1"){
        formRef.setFieldValue("surname_entrant", profileState.data.lastname);
        formRef.setFieldValue("name_entrant", profileState.data.firstname);
        formRef.setFieldValue("patronymic_entrant", profileState.data.middlename);

        formRef.setFieldValue("parent_surname", "");
        formRef.setFieldValue("parent_name", "");
        formRef.setFieldValue("parent_patronymic_entrant", "");

        setFormData({...allFields,
          surname_entrant: profileState.data.lastname,
          name_entrant: profileState.data.firstname,
          patronymic_entrant: profileState.data.middlename,
          parent_surname: "",
          parent_name: "",
          parent_patronymic_entrant: "",
        })
      } else {
        formRef.setFieldValue("parent_surname", profileState.data.lastname);
        formRef.setFieldValue("parent_name", profileState.data.firstname);
        formRef.setFieldValue("parent_patronymic_entrant", profileState.data.middlename);

        formRef.setFieldValue("surname_entrant", "");
        formRef.setFieldValue("name_entrant", "");
        formRef.setFieldValue("patronymic_entrant", "");

        setFormData({...allFields,
          parent_surname: profileState.data.lastname,
          parent_name: profileState.data.firstname,
          parent_patronymic_entrant: profileState.data.middlename,
          surname_entrant: "",
          name_entrant: "",
          patronymic_entrant: "",
        })
      }
    } else {
      setFormData(allFields)
    }


  }

  useEffect(() => {
    if(applicationData && profileState.success && !applicationData.name_entrant && !isExecutor) {
      formRef.setFieldValue("surname_entrant", profileState.data.lastname);
      formRef.setFieldValue("name_entrant", profileState.data.firstname);
      formRef.setFieldValue("patronymic_entrant", profileState.data.middlename);
      formRef.setFieldValue("email_entrant", profileState.data.email)

      setFormData({...formData, surname_entrant: profileState.data.lastname,
        name_entrant: profileState.data.firstname,
        patronymic_entrant: profileState.data.middlename,
        email_entrant:profileState.data.email });
    }
  }, [profileState.success, applicationData]);

  useEffect(() => {
    if((!checkIinState.data && checkIinState.failed) || (!checkEmailState.data && checkEmailState.failed)){
      setError(true)
    } else {
      setError(false)
    }
    //eslint-disable-next-line
  }, [checkIinState.success, checkEmailState.success])

  useEffect(() => {
    if(applicationData && applicationData.iin_entrant){
      formRef.setFieldsValue(initValue)
    }
    //eslint-disable-next-line
  }, [applicationData])

  /**
   * @description Func, that take **formData.declarant_type** and return label **parent** or **legal representative**
   * @return string
   */
  const getParentLabel = () => {
    let obj = {
      '2': 'родителя',
      '3': 'законного представителя'
    }

    // @ts-ignore
    return obj[formData.declarant_type]
  }

  const onCustomIinChange = (e:any) => {
    if(e.length === 12){
      dispatch(fetchCheckIinAction(e))
    }
  }

  const onChangeSelect = (key:any, option:any) => {
    setIdxForSelect(prevState => ({
      ...prevState,
      [key]: option.id
    }))
  }

  const handleFillForm = () => {
    formRef.setFieldsValue({
      declarant_type: "1",
      declarant_status: "1",
      iin_entrant: Array.from({ length: 12 }, () => Math.floor(Math.random() * 10)).join(''),
      surname_entrant: "surname",
      name_entrant: "name",
      declarant_address: "asdsad",
      phone_entrant: "+77777777777",
      email_entrant: "example@mail.com",
      base_education: "1",
      child_invalid: "2",
      quota: "2",
      country: "ru",
      hostel: "2",
      social_help: "2",
      accepted: "1",
      user_accepted : "1",
    })
  }

  const handleEmailCheck = () => {

    if(new RegExp(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/gm).test(formData.email_entrant)){
      if(!isExecutor){
        dispatch(fetchCheckEmailAction(formData.email_entrant))
      }
    }
  }


  return (
    <StyledFirstStep>
      <div className="header">
        <h2>
          {t("stepOne.title")}
        </h2>
      </div>

      <ConfigProvider locale={locale}>

      <Spin spinning={educationOrder.loading}>
        <div className="body">
          <Form labelWrap {...layout} form={formRef} onFinishFailed={onFinishFailed} onFinish={onFinish}
                initialValues={initValue} onValuesChange={onValuesChange} autoComplete="off" name="first_step_from"
                validateMessages={{
                  string: {
                    // eslint-disable-next-line no-template-curly-in-string
                    len: '${label} должен состоять из ${len} цифр'
                  },
                }}>
            <Row justify="space-between">
              <h3>{t("stepOne.label")}</h3>
              {(process.env.REACT_APP_ENV === 'local' || process.env.REACT_APP_ENV === 'development') && <Button onClick={() => handleFillForm()}>Заполнить заявление</Button>}
            </Row>

            <Form.Item name='declarant_type' label={t('stepOne.specialtyType.label')}
                       rules={[{ required: true, message: t("stepOne.typeError") }]}>
              <Select placeholder={t('stepOne.specialtyType.selectList')}>
                <Option value='1'>{t('stepOne.specialtyType.entrant')}</Option>
                <Option value='2'>{t('stepOne.specialtyType.parent')}</Option>
                <Option value='3'>{t('stepOne.specialtyType.representative')}</Option>
              </Select>
            </Form.Item>

            {formData.declarant_type && formData.declarant_type !== '1' ? (
              <>
                <Form.Item name='declarant_status' label={`${t('stepOne.typeOfPerson.label')} ${getParentLabel()}`}
                           rules={[{ required: true, message: t("statusError") }]}>
                  <Select placeholder={t('stepOne.typeOfPerson.selectList')}>
                    <Option value='1'>{t('stepOne.typeOfPerson.citizen')}</Option>
                    <Option value='2'>{t('stepOne.typeOfPerson.candace')}</Option>
                    <Option value='3'>{t('stepOne.typeOfPerson.foreigner')}</Option>
                    <Option value='4'>{t('stepOne.typeOfPerson.refuge')}</Option>
                    <Option value='5'>{t('stepOne.typeOfPerson.asylumSeeker')}</Option>
                    <Option value='6'>{t('stepOne.typeOfPerson.withoutCitizenship')}</Option>
                  </Select>
                </Form.Item>
                <Form.Item name='iin_parent' label={`ИИН ${getParentLabel()}`}
                           rules={[{
                             required: true,
                             message: `${t("stepOne.parentIinError")} ${getParentLabel()}`,
                             pattern: new RegExp(/^[0-9]+$/)
                           }, { len: 12 }]}>
                  {/*disabled={!!educationOrderData.iin_parent}*/}
                  <MyInput placeholder={`${t("stepOne.placeholderIinParent")} ${getParentLabel()}`} maxLength={12}/>
                </Form.Item>
                <Form.Item name='parent_surname' label={`Фамилия ${getParentLabel()}`}
                           rules={[{ required: true, message: `Необходимо ввести фамилию ${getParentLabel()}` }]}>
                  <MyInput placeholder={`Введите фамилию ${getParentLabel()}`} maxLength={250}/>
                </Form.Item>
                <Form.Item name='parent_name' label={`Имя ${getParentLabel()}`}
                           rules={[{ required: true, message: `Необходимо ввести имя ${getParentLabel()}` }]}>
                  <MyInput placeholder={`Введите имя ${getParentLabel()}`} maxLength={250}/>
                </Form.Item>
                <Form.Item name='parent_patronymic_entrant' label={t('stepOne.patronymic.label')}>
                  <MyInput placeholder={`Введите отчество ${getParentLabel()}`} maxLength={250}/>
                </Form.Item>
                <Form.Item name='birthday_parent' label={t('stepOne.parentBirthday.label')} rules={[{ required: true, message: `Необходимо ввести дату рождения ${getParentLabel()}` }]}>
                  <DatePicker format={"DD.MM.YYYY"} style={{width: "100%"}} placeholder={`Введите дату рождения ${getParentLabel()}`}/>
                </Form.Item>


                <hr/>
              </>
            ) : null}

            {error && checkIinState.failed ?
              <Alert
                className="admission__error"
                message={t("stepOne.checkIinError")}
                type="error"
                showIcon
                icon={warningIcon}
              />
              : null}

            <Form.Item name='iin_entrant' label={t('stepOne.iin.label')}
                       rules={[{
                         required: true,
                         message: t("stepOne.regexpIinError"),
                         pattern: new RegExp(/^[0-9]+$/)
                       }, { len: 12 }]}>
              {/*disabled={!!educationOrderData.iin_entrant}*/}
              <MyInput placeholder={`${t('stepOne.iin.placeholder')}`} maxLength={12}
                     onChange={(e) => onCustomIinChange(e.target.value)}/>
            </Form.Item>

            <Form.Item name='surname_entrant' label={t('stepOne.surname.label')}
                       rules={[{ required: true, message: t('stepOne.userSurnameError') }]}>
              <MyInput placeholder={`${t('stepOne.surname.placeholder')}`} maxLength={250}/>
            </Form.Item>

            <Form.Item name='name_entrant' label={t('stepOne.name.label')}
                       rules={[{ required: true, message: t('stepOne.userNameError') }]}>
              <MyInput placeholder={`${t('stepOne.name.placeholder')}`} maxLength={250}/>
            </Form.Item>

            <Form.Item name='patronymic_entrant' label={t('stepOne.patronymic.label')}>
              <MyInput placeholder={`${t('stepOne.patronymic.placeholder')}`} maxLength={250}/>
            </Form.Item>

            <Form.Item name='birthday_entrant' label={t('stepOne.entrantBirthday.label')} rules={[{ required: true, message: t('stepOne.entrantBirthdayError') }]}>
              <DatePicker format={"DD.MM.YYYY"}  style={{width: "100%"}} placeholder={`${t('stepOne.entrantBirthday.placeholder')}`}/>
            </Form.Item>

            {formData.declarant_type === '1' ? (
              <Form.Item name='declarant_status' label={t('stepOne.typeOfPerson.label')}
                         rules={[{ required: true, message: t("stepOne.declarantStatusError") }]}>
                <Select placeholder={t('stepOne.typeOfPerson.selectList')}>
                  <Option value='1'>{t('stepOne.typeOfPerson.citizen')}</Option>
                  <Option value='2'>{t('stepOne.typeOfPerson.candace')}</Option>
                  <Option value='3'>{t('stepOne.typeOfPerson.foreigner')}</Option>
                  <Option value='4'>{t('stepOne.typeOfPerson.refuge')}</Option>
                  <Option value='5'>{t('stepOne.typeOfPerson.asylumSeeker')}</Option>
                  <Option value='6'>{t('stepOne.typeOfPerson.withoutCitizenship')}</Option>
                </Select>
              </Form.Item>
            ) : null}

            <Form.Item name='declarant_address' label={t('stepOne.address.label')}
                       rules={[{ required: true, message: t("stepOne.addressError") }]}>
              <MyInput placeholder={`${t('stepOne.address.placeholder')}`} maxLength={250}/>
            </Form.Item>

            <Form.Item name='phone_entrant' label={t('stepOne.phoneNumber.label')}
                       rules={[{
                         required: true,
                         message: t("stepOne.entrantPhoneError"),
                         pattern: new RegExp(/^[+][0-9]{11}$/)
                       }]}>
              <MyInput placeholder='+7 777 777 77 77' maxLength={12}/>
            </Form.Item>

            <Form.Item name='email_entrant' label={t('stepOne.email.label')}
                       rules={[{
                         required: true,
                         message: t("stepOne.entrantEmailError"),
                         pattern: new RegExp(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/gm)
                       }]}>
              <MyInput onBlur={() => handleEmailCheck()} placeholder={`${t('stepOne.email.placeholder')}`} maxLength={250}/>
            </Form.Item>

            <Divider style={{paddingTop: 6, paddingBottom: 6}} />
            <h3>{t('stepOne.basicEducation.label')}</h3>

            <Form.Item name='country' label={t('stepThree.infoAboutEducation.country')}
                       rules={[{ required: true, message: t("stepOne.countryError") }]} style={{ marginTop: 0 }}>
              <Select placeholder={t('selectFromList')} showSearch={true}
                            optionFilterProp="children"
                // disabled={!!educationOrderData.country}
                            filterOption={(input: any, option: any) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                {countries.map(country => (
                  <Option key={country.value} value={country.value}>{t(`${country.label}`)}</Option>
                ))}
              </Select>
            </Form.Item>

            {provincesState.success ? <>
              {formData.country === 'kz' ?
                <Form.Item name='region' label={t('stepThree.infoAboutEducation.province')}
                           rules={[{ required: true, message: t("stepOne.regionError") }]} style={{ marginTop: 0 }}>
                  <Select placeholder={t('selectFromList')}
                                onChange={(value, option) => onChangeSelect('idxProvince', option)} showSearch={true}
                                optionFilterProp="children"
                    // disabled={!!educationOrderData.region}

                                value={formData.region}
                                filterOption={(input: any, option: any) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                    {provincesState.data && provincesState.data.map((province: any, idx: any) => (
                      <Option key={province.id} id={idx} value={province.id}>{province.caption}</Option>
                    ))}
                  </Select>
                </Form.Item> : null}

              {/*{formData.region === 1 || (educationOrder && educationOrder.district === '1') ?*/}
              {/*  <Form.Item name='district' label={t('stepThree.infoAboutEducation.region')}*/}
              {/*             rules={[{ required: true, message: 'Необходимо выбрать регион' }]}>*/}
              {/*    <Select placeholder={t('selectFromList')}*/}
              {/*                  onChange={(value, option) => onChangeSelect('idxRegion', option)} showSearch={true}*/}
              {/*                  optionFilterProp="children"*/}
              {/*      // disabled={!!educationOrderData.district}*/}
              {/*                  filterOption={(input: any, option: any) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>*/}
              {/*      {idxForSelect.idxProvince ? provincesState.data[idxForSelect.idxProvince].regions.map((region: any, idx: any) => (*/}
              {/*          <Option key={region.id} id={idx} value={region.id}>{region.caption}</Option>*/}
              {/*        ))*/}
              {/*        : provincesState.data.find((item: any) => item.id === initValue.region).regions.map((region: any, idx: any) => (*/}
              {/*          <Option key={region.id} id={idx} value={region.id}>{region.caption}</Option>*/}
              {/*        ))*/}
              {/*      }*/}
              {/*    </Select>*/}
              {/*  </Form.Item>*/}
              {/*  : null*/}
              {/*}*/}
            </> : <Row justify="center" align="middle"><Spin spinning={provincesState.loading} /></Row>}

            <Form.Item name='base_education' label={t('stepOne.basicEducation.label')}
                       rules={[{ required: true, message: t("stepOne.baseEducationError") }]}>
              <Select placeholder={t('stepOne.basicEducation.selectList')}>
                <Option value='1'>{t('stepOne.basicEducation.basicMiddle')}</Option>
                <Option value='2'>{t('stepOne.basicEducation.generalMiddle')}</Option>
                {/*<Option value='3'>{t('stepOne.basicEducation.generalHigher')}</Option>*/}
                <Option value='4'>{t('stepOne.basicEducation.tipo')}</Option>
              </Select>
            </Form.Item>

            <Divider style={{paddingTop: 6, paddingBottom: 6}} />
            <h3>Квоты</h3>

            <Form.Item name="child_invalid" label={t('stepOne.invalidChild.label')}
                       rules={[{ required: true, message: t("stepOne.childInvalidError") }]} className='item-border-bottom'>
              <Radio.Group size='large'>
                <Radio value="1">{t('stepOne.invalidChild.yes')}</Radio>
                <Radio value="2">{t('stepOne.invalidChild.no')}</Radio>
              </Radio.Group>
            </Form.Item>

            <Form.Item name="quota" label={t('stepOne.quota.label')}
                       rules={[{ required: true, message: t("stepOne.quoteError") }]}
                       className='item-border-bottom'>
              <Radio.Group size='large'>
                <Radio value="1">{t('stepOne.quota.yes')}</Radio>
                <Radio value="2">{t('stepOne.quota.no')}</Radio>
              </Radio.Group>
            </Form.Item>

            {formData.quota === '1' ?
              (<div>
                <Form.Item name="invalid1and2" labelCol={{ span: 14 }}
                           label={t('stepOne.quota.listOfQuotes.invalid1and2')}
                           rules={[{ required: true, message: t("stepOne.selectQuoteError") }]}
                           className='item-border-bottom'>
                  <Radio.Group size='large'>
                    <Radio value="1">{t('stepOne.quota.yes')}</Radio>
                    <Radio value="2">{t('stepOne.quota.no')}</Radio>
                  </Radio.Group>
                </Form.Item>
                <Form.Item name="vov" labelCol={{ span: 14 }}
                           label={t('stepOne.quota.listOfQuotes.vov')}
                           rules={[{ required: true, message: t("stepOne.selectQuoteError") }]}
                           className='item-border-bottom'>
                  <Radio.Group size='large'>
                    <Radio value="1">{t('stepOne.quota.yes')}</Radio>
                    <Radio value="2">{t('stepOne.quota.no')}</Radio>
                  </Radio.Group>
                </Form.Item>
                <Form.Item name="village_soc_ek" labelCol={{ span: 14 }}
                           label={t('stepOne.quota.listOfQuotes.village_soc_ek')}
                           rules={[{ required: true, message: t("stepOne.selectQuoteError") }]}
                           className='item-border-bottom'>
                  <Radio.Group size='large'>
                    <Radio value="1">{t('stepOne.quota.yes')}</Radio>
                    <Radio value="2">{t('stepOne.quota.no')}</Radio>
                  </Radio.Group>
                </Form.Item>
                <Form.Item name="faces_kaz_nac_without_rk" labelCol={{ span: 14 }}
                           label={t('stepOne.quota.listOfQuotes.faces_kaz_nac_without_rk')}
                           rules={[{ required: true, message: t("stepOne.selectQuoteError") }]}
                           className='item-border-bottom'>
                  <Radio.Group size='large'>
                    <Radio value="1">{t('stepOne.quota.yes')}</Radio>
                    <Radio value="2">{t('stepOne.quota.no')}</Radio>
                  </Radio.Group>
                </Form.Item>
                <Form.Item name="children_without_parent" labelCol={{ span: 14 }}
                           label={t('stepOne.quota.listOfQuotes.children_without_parent')}
                           rules={[{ required: true, message: t("stepOne.selectQuoteError") }]}
                           className='item-border-bottom'>
                  <Radio.Group size='large'>
                    <Radio value="1">{t('stepOne.quota.yes')}</Radio>
                    <Radio value="2">{t('stepOne.quota.no')}</Radio>
                  </Radio.Group>
                </Form.Item>
                <Form.Item name="village_rk" labelCol={{ span: 14 }}
                           label={t('stepOne.quota.listOfQuotes.village_rk')}
                           rules={[{ required: true, message: t("stepOne.selectQuoteError") }]}
                           className='item-border-bottom'>
                  <Radio.Group size='large'>
                    <Radio value="1">{t('stepOne.quota.yes')}</Radio>
                    <Radio value="2">{t('stepOne.quota.no')}</Radio>
                  </Radio.Group>
                </Form.Item>
                <Form.Item name="children_many" labelCol={{ span: 14 }}
                           label={t('stepOne.quota.listOfQuotes.children_many')}
                           rules={[{ required: true, message: t("stepOne.selectQuoteError") }]}
                           className='item-border-bottom'>
                  <Radio.Group size='large'>
                    <Radio value="1">{t('stepOne.quota.yes')}</Radio>
                    <Radio value="2">{t('stepOne.quota.no')}</Radio>
                  </Radio.Group>
                </Form.Item>
                <Form.Item name="family_half" labelCol={{ span: 14 }}
                           label={t('stepOne.quota.listOfQuotes.family_half')}
                           rules={[{ required: true, message: t("stepOne.selectQuoteError") }]}
                           className='item-border-bottom'>
                  <Radio.Group size='large'>
                    <Radio value="1">{t('stepOne.quota.yes')}</Radio>
                    <Radio value="2">{t('stepOne.quota.no')}</Radio>
                  </Radio.Group>
                </Form.Item>
                <Form.Item name="family_with_invalid" labelCol={{ span: 14 }}
                           label={t('stepOne.quota.listOfQuotes.family_with_invalid')}
                           rules={[{ required: true, message: t("stepOne.selectQuoteError") }]}
                           className='item-border-bottom'>
                  <Radio.Group size='large'>
                    <Radio value="1">{t('stepOne.quota.yes')}</Radio>
                    <Radio value="2">{t('stepOne.quota.no')}</Radio>
                  </Radio.Group>
                </Form.Item>
                <Form.Item name="conscript" labelCol={{ span: 14 }}
                           label={t("stepOne.quota.listOfQuotes.conscript")}
                           rules={[{ required: true, message: t("stepOne.selectQuoteError") }]}
                           className='item-border-bottom'>
                  <Radio.Group size='large'>
                    <Radio value="1">{t('stepOne.quota.yes')}</Radio>
                    <Radio value="2">{t('stepOne.quota.no')}</Radio>
                  </Radio.Group>
                </Form.Item>
              </div>) : null}

            <Form.Item name="hostel" label={t('stepOne.hostel.label')}
                       rules={[{ required: true, message: t("stepOne.hostelError") }]}
                       className='item-border-bottom'>
              <Radio.Group size='large'>
                <Radio value="1">{t('stepOne.hostel.yes')}</Radio>
                <Radio value="2">{t('stepOne.hostel.no')}</Radio>
              </Radio.Group>
            </Form.Item>

            <Form.Item name="social_help" label={t('stepOne.asp.label')}
                       rules={[{ required: true, message: t("stepOne.selectQuoteError") }]}
                       className='item-border-bottom'>
              <Radio.Group size='large'>
                <Radio value="1">{t('stepOne.asp.yes')}</Radio>
                <Radio value="2">{t('stepOne.asp.no')}</Radio>
              </Radio.Group>
            </Form.Item>

            {/*<Form.Item name="enbek" label="Участник государственной программы «Еңбек»"*/}
            {/*           rules={[{ required: true, message: t("stepOne.selectQuoteError") }]}*/}
            {/*           className='item-border-bottom'>*/}
            {/*  <Radio.Group size='large'>*/}
            {/*    <Radio value="1">Да</Radio>*/}
            {/*    <Radio value="2">Нет</Radio>*/}
            {/*  </Radio.Group>*/}
            {/*</Form.Item>*/}


            {profileState.data && Array.isArray(profileState.data.roles) && profileState.data.roles.some((item: any) => item === "executor") ? null : (
              <>
                <Divider style={{paddingTop: 6, paddingBottom: 6}} />
                <h4>{t('stepOne.acceptingRights.label')}</h4>

                <ol className='item-border-bottom'>
                  <li>{t('stepOne.acceptingRights.li1')}</li>
                  <li>{t('stepOne.acceptingRights.li2')}</li>
                  <li>{t('stepOne.acceptingRights.li3')}</li>
                  <li>{t('stepOne.acceptingRights.li4')}</li>
                  <li>{t('stepOne.acceptingRights.li5')}</li>
                </ol>

                <Form.Item name="accepted" valuePropName="checked"
                           rules={[{
                             validator: (_, value) =>
                               value ? Promise.resolve() : Promise.reject(new Error(t("stepOne.check1Error"))),
                           }]}
                           className='item-border-bottom'>
                  <MyCheckbox> {t('stepOne.acceptingRights.check1')} </MyCheckbox>
                </Form.Item>
              </>
            )}

            {isExecutor ? (
                <>
                  <Divider style={{paddingTop: 6, paddingBottom: 6}} />
                  <Form.Item name="user_accepted" valuePropName="checked"
                             rules={[{
                               validator: (_, value) =>
                                   value ? Promise.resolve() : Promise.reject(new Error(t("stepOne.check1Error"))),
                             },]}>
                    <MyCheckbox><Trans i18nKey='executorAdmissionSteps.stepOne.acceptingRights.check2'>
                      {t('stepOne.acceptingRights.checkLabel1')} <a target="_blank"
                                                                    href='https://ffa.object.pscloud.io/skuggcke/oykcaokq/iyuqmagg/cc3de6db0dd6166f89046a6ff331b977f1ac75ee.docx'
                                                                    rel="noreferrer">
                      {t('stepOne.acceptingRights.tagA')}</a> {t('stepOne.acceptingRights.checkLabel2')}
                    </Trans> </MyCheckbox>
                    {/*<Checkbox> Пользователь подтверждает что, ознакомлен со всеми пунктами настоящего <a target="_blank"
							 href='https://ff2.object.pscloud.io/giwycqkw/oykcaokq/iyuqmagg/efa32ff1d880f695404e1c060080f477c3307544.pdf'>Соглашение
							 о правах использования веб-портала «college.bilimal.kz»</a> и безусловно принимает их. </Checkbox>*/}
                  </Form.Item>

                  <p style={{color: '#49494D'}}><span className="textDanger">*</span> {t("stepOne.anotherText")}</p>
                </>
            ) : null}
          </Form>
        </div>
      </Spin>
      </ConfigProvider>


    </StyledFirstStep>
  )
}